var map = {
	"./gol.json": [
		211,
		211
	],
	"./phylogenetic_trees.json": [
		4,
		4
	],
	"./res.json": [
		880,
		880
	],
	"./this_website.json": [
		462,
		462
	],
	"./university_projects.json": [
		423,
		423
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 126;
module.exports = webpackAsyncContext;